import React from "react";
import "./Login.css";

const remove = () => {
  const loginFunc = document.querySelector(".login-container");
  loginFunc.classList.add("hide");
};

const Login = () => {
  return (
    <div className="login-container hide">
      <div className="login">
        <div
          className="cross"
          onClick={() => {
            remove();
          }}
        >
          <i className="fa-solid fa-circle-xmark"></i>
        </div>
        <div className="login-head">
          <p style={{fontSize:"20px"}}>
            Let's experience the Mock Interviews with Realtime Feedback!
          </p>
        </div>
        <div className="login-system">
          <div className="col vertical-line">
            <h1 style={{marginBottom:"0px"}}>Sign In as a Student</h1>
            <h5 style={{textAlign:"center",marginBottom:"55px"}}>Be an Interviewee! </h5>
            <form action={`${process.env.REACT_APP_SERVER_URL}/auth/google`}>
              <button className="signin-btn login" type="submit">
                <img src={require("../../images/google.png")} alt="Google" />
                Sign In with Google
              </button>
            </form>
            <form action={`${process.env.REACT_APP_SERVER_URL}/auth/facebook`}>
              <button className="signin-btn login" type="submit">
                <img
                  src={require("../../images/facebook.png")}
                  alt="Facebook"
                />
                Sign In with Facebook
              </button>
            </form>

            <form action={`${process.env.REACT_APP_SERVER_URL}/auth/linkedin`}>
              <button className="signin-btn login" type="submit">
                <img
                  src={require("../../images/linkedin.png")}
                  alt="Linkedin"
                />
                Sign In with Linkedin
              </button>
            </form>
          </div>
          <div className="col">
            <h1 style={{marginBottom:"0px"}}>Sign In as a Professional</h1>
            <h5 style={{textAlign:"center",marginBottom:"55px"}}>Be an Interviewer! </h5>
            <form action="http://localhost:4545/i/auth/i/google">
              <button className="signin-btn login" type="submit">
                <img src={require("../../images/google.png")} alt="Google" />
                Sign In with Google
              </button>
            </form>
            <form action={`${process.env.REACT_APP_SERVER_URL}/auth/i/facebook`}>
              <button className="signin-btn login" type="submit">
                <img
                  src={require("../../images/facebook.png")}
                  alt="Facebook"
                />
                Sign In with Facebook
              </button>
            </form>

            <form action={`${process.env.REACT_APP_SERVER_URL}/auth/i/linkedin`}>
              <button className="signin-btn login" type="submit">
                <img
                  src={require("../../images/linkedin.png")}
                  alt="Linkedin"
                />
                Sign In with Linkedin
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
